/** Dansk tidsformatering for clockin-fladerne (24-timers, "07.32"). */

export const klokken = new Intl.DateTimeFormat("da-DK", {
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Copenhagen",
});

export function formatMinutter(min: number): string {
  const t = Math.floor(min / 60);
  const m = min % 60;
  return t > 0 ? `${String(t)} t ${String(m)} m` : `${String(m)} m`;
}

/** Løbende varighed: MM:SS under en time, ellers TT:MM. */
export function formatVarighed(ms: number): string {
  const sekunder = Math.max(0, Math.floor(ms / 1000));
  if (sekunder < 3600) {
    const m = Math.floor(sekunder / 60);
    const s = sekunder % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }
  const t = Math.floor(sekunder / 3600);
  const m = Math.floor((sekunder % 3600) / 60);
  return `${String(t)}:${String(m).padStart(2, "0")}`;
}
